module.exports = __webpack_public_path__ + "TRUONGcontact-2.c9a517e0.png";